import {
    SET_FORM_SUBMITTING,
    UPDATE_FORM_VALUE,
    UPDATE_FORM_INITIAL_VALUE,
    CLEAR_FORM_GROUPS,
    UPDATE_FORM_GROUP_VALUE,
    SET_FORM_GROUP_VALUES,
    UPDATE_FORM_TOUCHED,
    SET_FORM_INITIAL_VALUES,
    SET_FORM_VALUES,
    SET_FORM_ERRORS,
    SET_FORM_NODE_ERROR,
    SET_FORM_GROUP_ERRORS,
    SET_FORM_TOUCHED,
    SET_FORM_VISIBILITY,
    SET_FORM_GROUP_VISIBILITY,
    SET_FIELD_ERROR,
    SET_FORM_META,
    SET_FORM_METAS,
    SET_SELECTED_SESSIONS,
    TOGGLE_SELECTED_SESSION,
} from '../constants/actionTypes';

export const setFormSubmitting = (isSubmitting) => ({
    type: SET_FORM_SUBMITTING,
    payload: {
        isSubmitting,
    },
});

export const updateFormDefaultValue = (id, value) => ({
    type: UPDATE_FORM_VALUE,
    payload: {
        id,
        value,
    },
});

export const updateFormInitialValue = (id, value) => ({
    type: UPDATE_FORM_INITIAL_VALUE,
    payload: {
        id,
        value,
    },
});

export const clearFormGroups = () => ({
    type: CLEAR_FORM_GROUPS,
});

/**
 * Updates a value inside the values object within a specific group.
 * @param {string} id - key inside the values object.
 * @param {string} group - name of the group.
 * @param {mixed} value.
 * @return {Object} - action
 */
export const updateFormGroupValue = (id, group, value) => ({
    type: UPDATE_FORM_GROUP_VALUE,
    payload: {
        id,
        group,
        value,
    },
});

export const updateFormValue = (id, value, group) =>
    group ? updateFormGroupValue(id, group, value) : updateFormDefaultValue(id, value);

export const updateFormTouched = (id, touched) => ({
    type: UPDATE_FORM_TOUCHED,
    payload: {
        id,
        touched,
    },
});

export const setFieldError = (id, error) => ({
    type: SET_FIELD_ERROR,
    payload: {
        id,
        error,
    },
});

export const setFormDefaultValues = (values) => ({
    type: SET_FORM_VALUES,
    payload: {
        values,
    },
});

export const setFormInitialValues = (initialValues) => ({
    type: SET_FORM_INITIAL_VALUES,
    payload: {
        initialValues,
    },
});

export const setFormGroupValues = (values, group) => ({
    type: SET_FORM_GROUP_VALUES,
    payload: {
        values,
        group,
    },
});

export const setFormErrors = (errors) => ({
    type: SET_FORM_ERRORS,
    payload: {
        errors,
    },
});

export const setFormMeta = (id, meta) => ({
    type: SET_FORM_META,
    payload: {
        id,
        meta,
    },
});

export const setFormMetas = (meta) => ({
    type: SET_FORM_METAS,
    payload: {
        meta,
    },
});

export const setFormNodeError = (errors, group, id) => ({
    type: SET_FORM_NODE_ERROR,
    payload: {
        errors,
        group,
        id,
    },
});

export const setFormGroupErrors = (errors, group) => ({
    type: SET_FORM_GROUP_ERRORS,
    payload: {
        errors,
        group,
    },
});

export const setFormTouched = (touched) => ({
    type: SET_FORM_TOUCHED,
    payload: {
        touched,
    },
});

export const setFormDefaultVisibility = (visibility) => ({
    type: SET_FORM_VISIBILITY,
    payload: {
        visibility,
    },
});

export const setFormGroupVisibility = (visibility, group) => ({
    type: SET_FORM_GROUP_VISIBILITY,
    payload: {
        visibility,
        group,
    },
});

export const setFormVisibility = (visibility, group) =>
    group ? setFormGroupVisibility(visibility, group) : setFormDefaultVisibility(visibility);

export const setFormValues = (values, group) =>
    group ? setFormGroupValues(values, group) : setFormDefaultValues(values);

export const setSelectedSessions = (sessions) => ({
    type: SET_SELECTED_SESSIONS,
    payload: {
        sessions,
    },
});

export const toggleSelectedSession = (sessionId) => ({
    type: TOGGLE_SELECTED_SESSION,
    payload: {
        sessionId,
    },
});
